import React, { useMemo,useState } from "react";
import { Box, Button, Card, Chip, Grid, Paper, Stack, Table, TableBody, TableContainer, TableHead, TableRow, Typography,FormControl, InputLabel, Select, MenuItem} from "@mui/material";
import styled from "@emotion/styled";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        padding: "10px",
        fontSize: 16,
        fontFamily: "Outfit, sans-serif",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        padding: "10px",
        fontFamily: "Outfit, sans-serif",
    },
}));

const InvoiceTable = () => {
    const [vendorFilter, setVendorFilter] = useState("all");
    const rows = [
        {
            id: 1,
            invoiceNumber: "AX1123453",
            invoiceDate: "15 JUL, 2025",
            vendor: "GRIL",
            certified: true,
            amount: "₹ 81 Lac",
            amountPaid: "₹ 67 Lac",
            amountWithheld: "₹ 14 Lac",
        },
        {
            id: 2,
            invoiceNumber: "AX1123454",
            invoiceDate: "20 AUG, 2025",
            vendor: "Gleeds",
            certified: false,
            amount: "₹ 62 Lac",
            amountPaid: "₹ 0.00",
            amountWithheld: "₹ 62 Lac",
        },
        {
            id: 3,
            invoiceNumber: "AX1123455",
            invoiceDate: "05 SEP, 2025",
            vendor: "GRIL",
            certified: true,
            amount: "₹ 79 Lac",
            amountPaid: "₹ 79 Lac",
            amountWithheld: "₹ 0.00",
        },
        {
            id: 4,
            invoiceNumber: "AX1123456",
            invoiceDate: "12 OCT, 2025",
            vendor: "Consultant-1",
            certified: true,
            amount: "₹ 45 Lac",
            amountPaid: "₹ 45 Lac",
            amountWithheld: "₹ 0.00",
        },
        // …add remaining rows as needed
    ];
    // UNIQUE vendor list
    const vendorOptions = useMemo(() => {
        const set = new Set(rows.map((r) => r.vendor));
        return ["all", ...Array.from(set)];
    }, [rows]);

    // FILTERED rows
    const filteredRows = useMemo(() => {
        if (vendorFilter === "all") return rows;
        return rows.filter((r) => r.vendor === vendorFilter);
    }, [rows, vendorFilter]);
    return (
        <Card
            elevation={0}
            sx={{
                borderRadius: 3,
                border: "1px solid #E4E4E4",
                width: '100%',
            }}
        >
            <Box sx={{
                width: '100%',
                borderBottom: "1px solid #E4E4E4",
                p: 1.5,
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <Box>
                    <Typography variant="subtitle1" sx={{
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 600,
                        fontSize: '20px',
                        letterSpacing: "0px",
                        mb: 0
                    }}>
                        Invoice Table
                    </Typography>
                    <Typography variant="body2" sx={{
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 300,
                        fontSize: '16px',
                        letterSpacing: "0px",
                        color: '#7D7F81'
                    }}>
                        List of all invoice details at a glance for quick review and action.
                    </Typography>
                </Box>
                <Box sx={{ width: 240,mr:3 }}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Vendor</InputLabel>
                        <Select
                        value={vendorFilter}
                        label="Vendor"
                        onChange={(e) => setVendorFilter(e.target.value)}
                        >
                        <MenuItem value="all">All Vendors</MenuItem>
                        {vendorOptions
                            .filter((v) => v !== "all")
                            .map((vendor) => (
                            <MenuItem key={vendor} value={vendor}>
                                {vendor}
                            </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </Box>
            <Grid contaier>
                <Grid size={12}>
                    <Paper
                        elevation={0}
                        sx={{
                            // borderRadius: 2,
                            // border: "1px solid #d1d5db",
                            overflow: "hidden",
                        }}
                    >
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow
                                        sx={{
                                            "& th": {
                                                fontWeight: 600,
                                                fontSize: 13,
                                                color: "#6b7280",
                                                borderBottom: "1px solid #e5e7eb",
                                                whiteSpace: "nowrap",
                                            },
                                        }}
                                    >
                                        <StyledTableCell>Invoice Number</StyledTableCell>
                                        <StyledTableCell>Invoice Date</StyledTableCell>
                                        <StyledTableCell>Vendor Name / Contractor Name</StyledTableCell>
                                        <StyledTableCell>Certified (Y/N)</StyledTableCell>
                                        <StyledTableCell align="right">Amount</StyledTableCell>
                                        <StyledTableCell align="right">Amount Paid</StyledTableCell>
                                        <StyledTableCell align="right">Amount Withheld</StyledTableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {filteredRows.map((row, index) => (
                                        <TableRow
                                            key={row.id}
                                            sx={{
                                                "& td": {
                                                    fontSize: 13,
                                                    borderBottom: "1px solid #f3f4f6",
                                                    paddingY: 1.25,
                                                },
                                                // light zebra effect
                                                backgroundColor:
                                                    index % 2 === 0 ? "#ffffff" : "#f9fafb",
                                            }}
                                        >
                                            <StyledTableCell>{row.invoiceNumber}</StyledTableCell>
                                            <StyledTableCell>{row.invoiceDate}</StyledTableCell>
                                            <StyledTableCell>{row.vendor}</StyledTableCell>
                                            <StyledTableCell>
                                                <Chip
                                                    label={row.certified ? "Yes" : "No"}
                                                    size="small"
                                                    sx={{
                                                        fontSize: 11,
                                                        height: 22,
                                                        borderRadius: "999px",
                                                        px: 1,
                                                        color: row.certified ? "#2563eb" : "#dc2626",
                                                        backgroundColor: row.certified
                                                            ? "#e0f2fe"
                                                            : "#fee2e2",
                                                    }}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell align="right">{row.amount}</StyledTableCell>
                                            <StyledTableCell align="right">{row.amountPaid}</StyledTableCell>
                                            <StyledTableCell align="right">{row.amountWithheld}</StyledTableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grid>
            </Grid>
        </Card>
    );
};

export default InvoiceTable;
